/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_launchpad__pois_hrt = /** @type {(inputs: {}) => string} */ () => {
	return `Sehenswürdigkeiten ansehen`
};

const en_launchpad__pois_hrt = /** @type {(inputs: {}) => string} */ () => {
	return `See points of interest`
};

const es_launchpad__pois_hrt = /** @type {(inputs: {}) => string} */ () => {
	return `Ver puntos de interés`
};

const fr_launchpad__pois_hrt = /** @type {(inputs: {}) => string} */ () => {
	return `Voir les points d’intérêts`
};

const it_launchpad__pois_hrt = /** @type {(inputs: {}) => string} */ () => {
	return `Vedere i punti di interesse`
};

const nl_launchpad__pois_hrt = /** @type {(inputs: {}) => string} */ () => {
	return `Nuttige punten bekijken`
};

const pt_launchpad__pois_hrt = /** @type {(inputs: {}) => string} */ () => {
	return `Ver pontos de interesse`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__pois_hrt = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.launchpad__pois_hrt(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("launchpad__pois_hrt", locale)
	if (locale === "de") return de_launchpad__pois_hrt(inputs)
	if (locale === "en") return en_launchpad__pois_hrt(inputs)
	if (locale === "es") return es_launchpad__pois_hrt(inputs)
	if (locale === "fr") return fr_launchpad__pois_hrt(inputs)
	if (locale === "it") return it_launchpad__pois_hrt(inputs)
	if (locale === "nl") return nl_launchpad__pois_hrt(inputs)
	return pt_launchpad__pois_hrt(inputs)
};